<template>
  <div>
    <el-tabs type="card" v-model="activeTab">
      <el-tab-pane label="Monthly Fee Group" name="monthlyFeeGroup">
        <group-manager />
      </el-tab-pane>
      <el-tab-pane label="Report" name="report">
        <report-manager />
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import groupManager from './components/group-manager.vue';
import reportManager from './components/report-manager.vue';
export default {
  components: {
    groupManager,
    reportManager
  },
  data() {
    return {
      activeTab: 'monthlyFeeGroup'
    }
  },

}
</script>

<style lang="scss" scoped></style>